import React, {Component} from 'react';
import logo from './../img/header_logo.png';

class DashboardMobile extends Component {
	state ={
		showDashboard :true
	}
	constructor(props) {
		super(props);
		this.state.showDashboard =true;
		
	}
	
	Demandeur = () => {
		this.props.forceStep(1);
		this.setState({showDashboard:false});
	}
	

	render() {

		return <>
			{ (this.state.showDashboard) ?
			<div id="dashboard">
				<div className="dashboard-header">
					
					<h1 className="bold centered">Découvrez les aides<br/> auxquelles vous avez droit</h1>
					<p>
						Estimation gratuite en <br/> quelques minutes (sans inscription)
					</p>
					<button className="mobile-start-btn" onClick={this.Demandeur}>
						Lancer mon estimation
					</button>
					<div className="dashboard-content">
						<ul className="custom-checklist">
							<li>Aucune inscription</li>
							<li>Données utilises uniquement pour le calcul</li>
							<li>Resultat immédiat</li>
						</ul>
					</div>
				</div> 

				<style>{`@media all and (max-width:700px) { .Steps { display: none !important; }}`}</style>
				
				 <img src={logo} alt="Info" className="logo-as" alt="Aide-sociale.fr" />
			</div>:''}
		</>;
	}
}

export default DashboardMobile;